import { config } from "../config";
import { getPlatform } from "../../utils/platform";

const APP_VERSION = (import.meta as any)?.env?.VITE_APP_VERSION ?? '';

export const getBaseHeaders = () => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-api-token': config.API_SECRET_TOKEN,
    'X-Client-Platform': getPlatform(), // 'ios' | 'android' | 'web'
  };
  if (APP_VERSION) {
    headers['X-Client-App-Version'] = APP_VERSION;
  }
  return headers;
};

export const handleApiError = async (response: Response, operation: string) => {
  let errorData;
  try {
    const data = await response.json();

    if (Array.isArray(data.detail)) {
      errorData = data.detail[0]?.msg || data.detail[0]?.message;
    } else {
      errorData = data.detail || data.message || data.error || response.statusText;
    }
  } catch (e) {
    errorData = response.statusText;
  }

  if (errorData) {
    throw new Error(errorData);
  }

  throw new Error(`${operation} failed: ${response.statusText}`);
};
